import { ObjectCommandDTO } from '@types'

export const getDefaultCommand = (commandsList: ObjectCommandDTO[], flag: string) => {
  return commandsList.find(command => command.flags.includes(flag)) || null
}
